import React from 'react'
import clsx from 'clsx'

const StatusBadge = ({ status, children, className }) => {
  const statusClasses = {
    success: 'badge-success',
    warning: 'badge-warning',
    danger: 'badge-danger',
    info: 'badge-info',
    gray: 'badge-gray'
  }

  return (
    <span className={clsx(
      'badge',
      statusClasses[status] || statusClasses.gray,
      className
    )}>
      {children}
    </span>
  )
}

export default StatusBadge